document.addEventListener('DOMContentLoaded', function () {
  
  // This Code was added to force default template for the  collection and products
  document.querySelectorAll('a[href]').forEach(anchor => {
    const href = anchor.getAttribute('href');

    // Skip empty, hash-only, mailto, tel links
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
      return;
    }

    // Only target product & collection URLs
    if (!href.includes('/products/') && !href.includes('/collections/')) {
      return;
    }

    try {
      const url = new URL(href, window.location.origin);

      // Add view=default only if not already present
      if (!url.searchParams.has('view')) {
        url.searchParams.set('view', 'default');
        anchor.setAttribute('href', url.pathname + url.search + url.hash);
      }
    } catch (e) {
      // Ignore invalid URLs
    }
  });



  const currentPath = window.location.pathname;
  document.querySelectorAll(".custom-shades-sec .custom__block .card-media--link").forEach(link => {
    const linkPath = new URL(link.href).pathname;

    if (linkPath === currentPath) {
      link.classList.add("active");
      link.closest(".custom__block")?.classList.add("active");
    }
  });
});
